/** @format */
import { SisStateDeclaration } from 'sis-components';
import { LoginErrorComponent } from './login-error.component';

export const loginErrorStates: SisStateDeclaration[] = [
    {
        name: 'student.login-error',
        url: '/login-error',
        component: LoginErrorComponent,
        data: {
            showHeader: false,
            headerWithoutBreadcrumbs: true,
        },
    },
];
